export default function fraudulentCustomersService($http) {
  return {
    block
  };

  function block(emails) {
    return $http.put('oc-api/operations/fraud/customers/block', {emails});
  }
}



// WEBPACK FOOTER //
// ./src/app/customers/fraudulent-customers/fraudulent-customers.service.js